exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FzpSk64hUv7N2IhETGcE4 ._1jTvnTTkKGBwaN-5tSdLyI{font-size:14px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}.FzpSk64hUv7N2IhETGcE4 ._2sWv11r_WNF2DvKGnDjZKg{width:263px}html[dir] .FzpSk64hUv7N2IhETGcE4 ._2sWv11r_WNF2DvKGnDjZKg{margin-top:15px;margin-bottom:24px}._8uZk1i4Kz6VS9PwWFmG80{display:block}html[dir=ltr] ._8uZk1i4Kz6VS9PwWFmG80 button{padding-left:11px}html[dir=rtl] ._8uZk1i4Kz6VS9PwWFmG80 button{padding-right:11px}", ""]);

// exports
exports.locals = {
	"shareACalendarWrapper": "FzpSk64hUv7N2IhETGcE4",
	"shareACalendarSectionMessage": "_1jTvnTTkKGBwaN-5tSdLyI",
	"dropdownContainer": "_2sWv11r_WNF2DvKGnDjZKg",
	"shareACalendarCallout": "_8uZk1i4Kz6VS9PwWFmG80"
};